import { defaultCache } from '@/app/core/cache';
import { AppUserProfile } from '@ssar-app/domain';

const OKTA_USER_STORAGE_KEY_NAME = 'ssar-okta-user';

const setOktaUserInfo = (oktaUserInfo: AppUserProfile): void => {
  defaultCache.set(OKTA_USER_STORAGE_KEY_NAME, JSON.stringify(oktaUserInfo));
};
const getOktaUserInfo = (): AppUserProfile => {
  if (!defaultCache.get(OKTA_USER_STORAGE_KEY_NAME)) {
    return {
      userName: '',
      email: '',
      firstName: '',
      lastName: '',
      sub: '',
      entitlements: [],
    };
  }
  return JSON.parse(defaultCache.get(OKTA_USER_STORAGE_KEY_NAME) || '{}') || {};
};

const getOktaInitials = (): string => {
  const userInfo = getOktaUserInfo();

  return (userInfo.firstName?.charAt(0) || '').concat(
    userInfo.lastName?.charAt(0) || '',
  );
};

const getUserName = (): string => {
  const userInfo = getOktaUserInfo();
  return userInfo.firstName
    ? userInfo.firstName.split(' ')[0] + ' ' + userInfo.lastName
    : userInfo.lastName;
};

const OktaUserInfo = {
  setOktaUserInfo,
  getOktaInitials,
  getOktaUserInfo,
  getUserName,
};

export { OktaUserInfo };
